import React from 'react';
import { Footer } from '../components/Footer';

import thank_you_img from '../../src/img/pages/ThankYou/thank_you.svg';
import Spiral from "../icon/testimonial/Spiral.svg";

const ThankYou = () => {
  return (
    <>
    <div className='w-[95%] mx-auto py-12 h-[75vh] min-h-[350px]: my-20 max-h-[600px] xl:w-[80%] flex items-center justify-center flex-col'>
      <div className='flex items-end justify-center relative w-[50%] mx-auto'>
          <img src={thank_you_img} alt="" />
          <div className='absolute w-[95%] opacity-70 top-[50%] items-center justify-between -z-10 xl:w-[80%] hidden sm:flex'>
               <img src={Spiral} alt="" />
               <img src={Spiral} alt="" />
          </div> 
      </div>
      <div>
         <h2 className='text-2xl md:text-3xl xl:text-[32px] leading-[32px] font-light text-center'> Thank you for submitting your enquiry. <br />
         One of our counselors will get in touch with you shortly!</h2>
      </div>
    </div>
    <Footer/>
    </>
  )
}

export default ThankYou;